import { Injectable } from '@angular/core';
import { HttpClient,HttpRequest,HttpHeaders } from '@angular/common/http';

import { BehaviorSubject, Observable } from 'rxjs';

import { User } from '../_models/user';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<any>;
    private selectedStore: BehaviorSubject<any>;

    public currentUser: Observable<any>;
    //private apiUrl = "http://api.astrolytics.info/api";
    private apiUrl = "https://api.astrolytics.info/api";
    //private apiUrl = "http://localhost:5000/api";

    private errorSubject: BehaviorSubject<any>;
    public errorObservable: Observable<any>;

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
        this.errorSubject = new BehaviorSubject<any>("");
        this.errorObservable = this.errorSubject.asObservable();
        if (localStorage.getItem('selectedStore')){
            this.selectedStore = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('selectedStore')));
        }
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    public get selectedStoreValue() : any {
        if (this.selectedStore){
            return this.selectedStore.value
        }

    }

    isAuth() : Boolean {
        return this.currentUserSubject.value != null;
    }

    login(username, password) {
        let headersConf = new HttpHeaders({ 'Content-Type': 'application/json', "Accept": "application/json" });
        let body = {
          "email": username,
          "pass": password,
        };
        this.http.post(this.apiUrl + "/login/astroselling", body, {headers:headersConf, observe: 'response'})
          .subscribe(
          (response) => {
              var data = response.body;

            if (data.toString().length == 0){
                this.errorSubject.next("Error de inicio de sesión. Compruebe que el nombre de usuario y contraseña son correctos");
            }
            else{
                localStorage.setItem('currentUser', JSON.stringify(data));
                var obj = <any>data;
                var stores = obj.stores;
                if (stores.length > 0){
                    localStorage.setItem("selectedStore", JSON.stringify(stores[0]));
                    this.selectedStore = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('selectedStore')));
                }
                this.currentUserSubject.next(data);
            }



        },
        (err) => {
            console.log(err);
            this.errorSubject.next("Ha ocurrido un error con la petición al servidor");
        }
        );


    }

    logout() {
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }

    changeSelectedStore(name){
        var stores = this.currentUserSubject.value.stores;
        for (var i = 0; i < stores.length ; i++){
            var current = stores[i];
            if (current.name == name){
                localStorage.removeItem("selectedStore");
                localStorage.setItem("selectedStore",JSON.stringify(current));
                this.selectedStore = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('selectedStore')));
            }
        }
    }
}